var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSurveyComplete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 214.307,
    height: 154.55,
    viewBox: "0 0 214.307 154.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3151",
    "data-name": "Gruppe 3151",
    transform: "translate(-80.347 -93.465)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3150",
    "data-name": "Gruppe 3150"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2503",
    "data-name": "Gruppe 2503",
    transform: "translate(124.191 106.742)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2499",
    "data-name": "Gruppe 2499"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3536",
    "data-name": "Pfad 3536",
    d: "M-1442.839,571.844H-1443a64.631,64.631,0,0,1-45.965-19.172,64.646,64.646,0,0,1-18.944-46.06,65.149,65.149,0,0,1,65.07-64.912h.16a64.656,64.656,0,0,1,45.966,19.172,64.641,64.641,0,0,1,18.944,46.06,64.448,64.448,0,0,1-6.582,28.385,4.64,4.64,0,0,1-6.215,2.135,4.646,4.646,0,0,1-2.135-6.215,55.215,55.215,0,0,0,5.637-24.329,55.406,55.406,0,0,0-16.238-39.479,55.417,55.417,0,0,0-39.4-16.434h-.136a55.841,55.841,0,0,0-55.774,55.641,55.406,55.406,0,0,0,16.238,39.479,55.409,55.409,0,0,0,39.4,16.434h.133a55.416,55.416,0,0,0,32.209-10.233,4.645,4.645,0,0,1,6.48,1.105,4.649,4.649,0,0,1-1.105,6.48A64.651,64.651,0,0,1-1442.839,571.844Z",
    transform: "translate(1507.906 -441.699)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2502",
    "data-name": "Gruppe 2502",
    transform: "translate(0.63 12.654)",
    opacity: 0.23
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2501",
    "data-name": "Gruppe 2501"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2500",
    "data-name": "Gruppe 2500"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3537",
    "data-name": "Pfad 3537",
    d: "M-1447.442,567.327a60.2,60.2,0,0,0,60.2-60.2,60.2,60.2,0,0,0-60.2-60.2,60.2,60.2,0,0,0-60.2,60.2,60.2,60.2,0,0,0,60.2,60.2",
    transform: "translate(1507.646 -446.921)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2488",
    "data-name": "Gruppe 2488",
    transform: "translate(98.45 223.287)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2487",
    "data-name": "Gruppe 2487"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3527",
    "data-name": "Pfad 3527",
    d: "M-1516.712,514.524a1.817,1.817,0,0,1-1.817-1.817V491.612a1.818,1.818,0,0,1,1.817-1.817,1.818,1.818,0,0,1,1.817,1.817v21.094A1.816,1.816,0,0,1-1516.712,514.524Z",
    transform: "translate(1518.529 -489.795)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2489",
    "data-name": "Gruppe 2489",
    transform: "translate(87.902 233.833)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3528",
    "data-name": "Pfad 3528",
    d: "M-1499.971,497.782h-21.094a1.817,1.817,0,0,1-1.818-1.817,1.818,1.818,0,0,1,1.818-1.817h21.094a1.818,1.818,0,0,1,1.817,1.817A1.817,1.817,0,0,1-1499.971,497.782Z",
    transform: "translate(1522.882 -494.147)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2491",
    "data-name": "Gruppe 2491",
    transform: "translate(251.117 93.465)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2490",
    "data-name": "Gruppe 2490"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3529",
    "data-name": "Pfad 3529",
    d: "M-1453.708,442.047a1.812,1.812,0,0,1-1.287-.533,1.815,1.815,0,0,1,0-2.569l2.2-2.193a1.815,1.815,0,0,1,2.569,0,1.815,1.815,0,0,1,0,2.569l-2.193,2.193A1.807,1.807,0,0,1-1453.708,442.047Z",
    transform: "translate(1455.527 -436.22)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2492",
    "data-name": "Gruppe 2492",
    transform: "translate(242.451 102.131)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3530",
    "data-name": "Pfad 3530",
    d: "M-1457.286,445.626a1.813,1.813,0,0,1-1.284-.533,1.818,1.818,0,0,1,0-2.571l2.193-2.193a1.818,1.818,0,0,1,2.571,0,1.822,1.822,0,0,1,0,2.571l-2.2,2.193A1.813,1.813,0,0,1-1457.286,445.626Z",
    transform: "translate(1459.103 -439.796)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2493",
    "data-name": "Gruppe 2493",
    transform: "translate(251.117 102.133)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3531",
    "data-name": "Pfad 3531",
    d: "M-1451.515,445.625a1.813,1.813,0,0,1-1.284-.533l-2.2-2.193a1.815,1.815,0,0,1,0-2.569,1.818,1.818,0,0,1,2.571,0l2.193,2.19a1.818,1.818,0,0,1,0,2.571A1.814,1.814,0,0,1-1451.515,445.625Z",
    transform: "translate(1455.527 -439.797)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2497",
    "data-name": "Gruppe 2497",
    transform: "translate(80.347 93.465)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2494",
    "data-name": "Gruppe 2494",
    transform: "translate(162.104)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3532",
    "data-name": "Pfad 3532",
    d: "M-1455.091,442.047a1.812,1.812,0,0,1-1.287-.533l-2.193-2.193a1.815,1.815,0,0,1,0-2.569,1.818,1.818,0,0,1,2.571,0l2.193,2.193a1.815,1.815,0,0,1,0,2.569A1.8,1.8,0,0,1-1455.091,442.047Z",
    transform: "translate(1459.103 -436.22)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2495",
    "data-name": "Gruppe 2495",
    transform: "translate(0 104.407)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3533",
    "data-name": "Pfad 3533",
    d: "M-1518.874,493.558a7.133,7.133,0,0,1-7.127-7.124,7.134,7.134,0,0,1,7.127-7.127,7.135,7.135,0,0,1,7.126,7.127A7.134,7.134,0,0,1-1518.874,493.558Zm0-10.616a3.494,3.494,0,0,0-3.492,3.492,3.494,3.494,0,0,0,3.492,3.489,3.5,3.5,0,0,0,3.491-3.489A3.5,3.5,0,0,0-1518.874,482.942Z",
    transform: "translate(1526 -479.307)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2496",
    "data-name": "Gruppe 2496",
    transform: "translate(189.583 9.617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3534",
    "data-name": "Pfad 3534",
    d: "M-1435.4,464.918a12.378,12.378,0,0,1-12.361-12.366,12.376,12.376,0,0,1,12.361-12.363,12.376,12.376,0,0,1,12.363,12.363A12.378,12.378,0,0,1-1435.4,464.918Zm0-21.094a8.738,8.738,0,0,0-8.726,8.728,8.74,8.74,0,0,0,8.726,8.731,8.739,8.739,0,0,0,8.728-8.731A8.737,8.737,0,0,0-1435.4,443.824Z",
    transform: "translate(1447.763 -440.189)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("line", {
    id: "Linie_324",
    "data-name": "Linie 324",
    y1: 36.235,
    x2: 36.235,
    transform: "translate(180.203 157.351)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_325",
    "data-name": "Linie 325",
    x1: 18.117,
    y1: 18.117,
    transform: "translate(162.086 175.468)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 10
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSurveyComplete);
export default __webpack_public_path__ + "static/media/icon_survey_complete.09508bb21aa2b31f7844c0981a489424.svg";
export { ForwardRef as ReactComponent };